export default function ErrorAlert(props) {

    if (!props.visible) {
        return null;
    }

    return (<span className="text-danger">
        Errors occurred <i className="bi bi-exclamation-circle"></i>
        <a className="btn btn-link text-reset ms-2 p-0 mb-1 fw-bold" onClick={() => window.scroll(0, 0)}>Go to Errors</a>
    </span>);
}